import * as React from 'react';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { DateRangePickerDay } from '@mui/x-date-pickers-pro/DateRangePickerDay';

import { isOperationToday } from 'shared/lib/dateFormatter';

/**
 * Calendar day cell whose "today" ring follows the operations day (LA), not the browser clock.
 * A user in Korea opening a date picker during the LA workday would otherwise see the ring on
 * what the LA team calls tomorrow and pick that day by habit.
 */
export function OperationPickersDay(props) {
    return <PickersDay {...props} today={isOperationToday(props.day)} />;
}

/** Same as OperationPickersDay for the range pickers (Quote Archive search, Activity, Data Export). */
export function OperationDateRangePickersDay(props) {
    return <DateRangePickerDay {...props} today={isOperationToday(props.day)} />;
}

export const operationDaySlot = { day: OperationPickersDay };
export const operationRangeDaySlot = { day: OperationDateRangePickersDay };
